import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=094ac192&"
import script from "./Approval.vue?vue&type=script&lang=ts&"
export * from "./Approval.vue?vue&type=script&lang=ts&"
import style0 from "./Approval.vue?vue&type=style&index=0&id=094ac192&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports